import { Text } from "@mantine/core";

import type { JSX } from "react";

export const IncomingChatCopy = (): JSX.Element => {
    return (
        <>
            <Text span fw="bold" size="xs">
                Pending chat
            </Text>
            <Text span size="xxs">
                Waiting on reply...
            </Text>
        </>
    );
};
